import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../services/auth.service';
import { CollaboratorService } from './../../../rest/api/collaborator.service';
import { HelperService } from './../../../services/helper.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import * as _ from 'lodash';

@Component({
  selector: 'app-collaborators',
  templateUrl: './collaborators.component.html',
  styleUrls: ['./collaborators.component.scss']
})
export class CollaboratorsComponent implements OnInit {

  accessToken: any;
  langShortCode: any;
  collaboratorLoader = true;
  collaboratorsData: any;
  pendingCollaborators: any;
  activeCollaborators: any;
  deletedCollaborators: any;

  inviteCollaboratorForm: FormGroup;

  successMsg: string;
  errorMsg: string;
  errors = [];


  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,
  ) {
      this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
      this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
  }

  ngOnInit() {
    this.getCollaboratorList();
  }

  getCollaboratorList() {
    this.collaboratorService.getCollaboratorList({
      Authorization: this.accessToken
    }).subscribe((response: any) => {
      this.collaboratorsData = response && response.data ? response.data : [];
      this.pendingCollaborators = this.collaboratorsData ? _.filter(this.collaboratorsData, {status: 'pending'}) : [];
      this.activeCollaborators = this.collaboratorsData ? _.filter(this.collaboratorsData, {status: 'active'}) : [];
      this.deletedCollaborators = _.filter(this.collaboratorsData, {status: 'deleted'});
      this.collaboratorLoader = false;
    }, err => {
      this.collaboratorsData = [];
      this.pendingCollaborators = [];
      this.activeCollaborators = [];
      this.deletedCollaborators = [];
      this.collaboratorLoader = false;
    });
  }

  inviteCollaboratorEmit(response) {
    if (response && response.success) {
      this.successMsg = 'We sent a fresh invitation. Once the user sets up the account, it will be listed in the active tab.';
    } else {
      this.handleErrors(response.errors);
    }
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Collaborators has been already added';
    }
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  inviteCollaboratorsEmit(response) {
    this.collaboratorsData.push(response);
    this.pendingCollaborators = _.filter(this.collaboratorsData, {status: 'pending'});
    this.activeCollaborators = _.filter(this.collaboratorsData, {status: 'active'});
    this.deletedCollaborators = _.filter(this.collaboratorsData, {status: 'deleted'});
  }

  deleteCollaboratorEmit(response) {
    this.collaboratorsData = _.map(this.collaboratorsData, (collab) => {
      if (response.uuid === collab.uuid) {
        return response;
      }
      return collab;
    });
    this.pendingCollaborators = _.filter(this.collaboratorsData, {status: 'pending'});
    this.activeCollaborators = _.filter(this.collaboratorsData, {status: 'active'});
    this.deletedCollaborators = _.filter(this.collaboratorsData, {status: 'deleted'});
  }

  reactivateCollaboratorEmit(response) {
    this.collaboratorsData = _.map(this.collaboratorsData, (collab) => {
      if (response.uuid === collab.uuid) {
        return response;
      }
      return collab;
    });
    this.pendingCollaborators = _.filter(this.collaboratorsData, {status: 'pending'});
    this.activeCollaborators = _.filter(this.collaboratorsData, {status: 'active'});
    this.deletedCollaborators = _.filter(this.collaboratorsData, {status: 'deleted'});
  }
}
